export default "__VITE_ASSET__7bc0ec1d__"